import { render, staticRenderFns } from "./TagPopup.vue?vue&type=template&id=000d4d91&"
import script from "./TagPopup.vue?vue&type=script&lang=ts&"
export * from "./TagPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports